import { useEffect, useState } from "react";
import "./TextStrip.css";

const TextStrip = ({ className, homeStrips }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sentences = homeStrips;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sentences.length);
    }, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [sentences.length]);

  return (
    <div className={`text-strip ${className || ""}`}>
      <p className="text-strip-content">
        {sentences?.[currentIndex]}
      </p>
    </div>
  );
};

export default TextStrip;